var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon_box",on:{"click":_vm.click}},[(_vm.isFullscreen)?_c('img',{attrs:{"src":require("@/assets/icon/min.png"),"alt":""}}):_c('img',{attrs:{"src":require("@/assets/icon/max.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }